module.exports = __webpack_public_path__ + "img/partner-2.e760b1bd.png";